import { I18n } from '@calendly/i18n'
import { Badge } from '@calendly/ui/components/badge'
import { BodyText } from '@calendly/ui/components/typography'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { colorTextSecondary, colorTextStandard } from '@calendly/ui/theme'
import moment from 'moment-timezone'
import { useSelector } from 'react-redux'

import { dateNotationSelector } from 'selectors/current_user'
import { userDateFormatCheckYear } from 'services/time_format'

import {
  DateBadgeContainer,
} from './styles'

export const DateBadge = ({ date }) => {
  const isPhone = useDeviceType('isPhone')
  const dateMmt = moment(date)
  const dateFormat = useSelector(dateNotationSelector)
  const isSameYear = dateMmt.year() === moment().year()
  const formats = isPhone
    ? { day: 'dddd', withoutYear: 'date_medium', withYear: 'date_medium_with_year' }
    : { day: 'ddd', withoutYear: 'date_small', withYear: 'date_small_with_year' }
  const dateStr = userDateFormatCheckYear(dateMmt, dateFormat, formats.withoutYear, formats.withYear)
  const isToday = dateMmt.isSame(moment(), 'day')

  return (
    <DateBadgeContainer isSameYear={isSameYear}>
      {isToday && <Badge type="active">{I18n.t('publisher.dashboard.filters.today')}</Badge>}
      {(isPhone || !isToday)
        && <BodyText weight="semibold" color={colorTextStandard}>{`${dateMmt.format(formats.day)}${isPhone ? ',' : ''}`}</BodyText>}
      <BodyText weight="semibold" color={isPhone ? colorTextStandard : colorTextSecondary}>{dateStr}</BodyText>
    </DateBadgeContainer>
  )
}
